<template>
    <div class="quarter-bank">
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-date-picker
                        v-model="monthDate"
                        type="year" placeholder="选择年">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getKpiMonthRankingList">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-popover
                        placement="top-start"
                        title="计算公式"
                        width="400"
                        trigger="hover">
                    <p>月度价值目标、实际价值计算公式：<br/>
                        (v1+v2+...)<br/>
                        <span style="color: #8c8c8c;font-size: 11px">v1:表示当月价值目标1<br/>
                        v2:表示当月价值目标2
                        </span><br/>
                        <br/>
                        完成率计算公式：<br/>
                        ((实际价值-月度价值目标)+ABS(月度价值目标))/ABS(月度价值目标)</p>
                    <el-button slot="reference" type="danger">查看完成率公式</el-button>
                </el-popover>
            </el-form-item>
        </el-form>

        <el-tabs v-model="activeName"  type="border" tab-position="left" @tab-click="handleClick">

                    <el-tab-pane  :key="item.id"
                                  v-for="(item, index) in months"
                                  :label="item.name"
                                  :name="index.toString()" >
                        <el-tabs v-model="activeName1"  type="card" tab-position="top" >

                        <el-tab-pane
                                      v-for="(item1, index1) in item.kpiType" :key="index1"
                                      :label="item1.name"
                                       >
                            <el-table :data="item1.data" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                                <el-table-column type="index" label="序号" width="50"></el-table-column>
                                <el-table-column label="部门" prop="deptName"></el-table-column>
                                <el-table-column label="姓名">
                                    <template slot-scope="scope">
                                        <a style="text-decoration: underline;cursor: pointer;" @click="getCooperativeQues(scope.row.paperId,scope.row.classId,scope.row.questionClassName,scope.row.userName,scope.row.periodName)">{{scope.row.userName}}</a>
                                    </template>
                                </el-table-column>
                                <el-table-column label="月度价值目标(万)" prop="value"></el-table-column>
                                <el-table-column label="实际价值(万)" prop="factValue"></el-table-column>
                                <el-table-column label="备注" prop="remark"></el-table-column>
                                <el-table-column label="完成率%" prop="rate"></el-table-column>
                                <el-table-column label="完成率排名" prop="row" sortable></el-table-column>
                                <el-table-column label="实际价值排名" prop="valueRow" sortable></el-table-column>
                                <el-table-column label="操作" fixed="right" width="90">
                                    <template slot-scope="scope">
                                        <el-button :disabled="scope.row.isEditRemark==0" type="danger" size="mini" @click="addRemark(scope.row)">备注</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>

                        </el-tabs>
                    </el-tab-pane>

        </el-tabs>
        <el-drawer
                :title="title"
                :visible.sync="drawerShow"
                direction="rtl"
                :before-close="handleClose" size="90%">
            <div style="padding: 5px 20px;" class="drawer-wrap">
                <el-table :data="quesList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column label="选择月" width="100">
                        <template slot-scope="scope">
                            <el-select :disabled="editIs==0" v-model="scope.row.month" placeholder="请选择月份" @change="formSubmit">
                                <el-option label="请选择" :value="null"></el-option>
                                <el-option :label="1+(formInline.period-1)*3+'月'" :value="1+(formInline.period-1)*3"></el-option>
                                <el-option :label="2+(formInline.period-1)*3+'月'" :value="2+(formInline.period-1)*3"></el-option>
                                <el-option :label="3+(formInline.period-1)*3+'月'" :value="3+(formInline.period-1)*3"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="选择KPI类型" width="120">
                        <template slot-scope="scope">
                            <el-select :disabled="editIs==0" v-model="scope.row.kpiType" placeholder="选择KPI类型" @change="formSubmit">
                                <!--                                <el-option label="请选择" :value="null"></el-option>-->
                                <el-option label="PL" :value="1"></el-option>
                                <el-option label="现金流" :value="2"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="目标价值确认">

                        <el-table-column label="目标描述">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="editIs==0"
                                          v-model="scope.row.kpi" size="mini" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="目标价值(万元)" width="120">
                            <template slot-scope="scope">
                                <el-input-number
                                        :disabled="editIs==0"
                                        v-model="scope.row.value" :controls="false" :precision="4" controls-position="right" @change="formSubmit"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="计算公式">
                            <template slot-scope="scope">
                                <el-input type="textarea"
                                          autosize
                                          :disabled="editIs==0"
                                          v-model="scope.row.formula" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="员工确认" prop="weight" width="90">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.confirm" :disabled="editIs==0" :true-label="1" :false-label="0" size="medium" @change="formSubmit"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column label="Leader确认" prop="weight" width="90">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.leaderConfirm" :disabled="editIs==0" :true-label="1" :false-label="0" size="medium" @change="formSubmit"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="实际达成确认">

                        <el-table-column label="实际创造价值(万元)" >
                            <template slot-scope="scope">
                                <el-input-number :disabled="editIs==0" v-model="scope.row.factValue" :controls="false" :precision="4" controls-position="right" @change="formSubmit"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column label="实际公式" >
                            <template slot-scope="scope">
                                <el-input :disabled="editIs==0" v-model="scope.row.factFormula" maxlength="500" @change="formSubmit"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="员工确认" prop="weight" width="90">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.factConfirm" :disabled="editIs==0" :true-label="1" :false-label="0" size="medium" @change="formSubmit"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column label="Leader确认" prop="weight" width="90">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.leaderFactConfirm" :disabled="editIs==0" :true-label="1" :false-label="0" size="medium" @change="formSubmit"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table-column>


                </el-table>
            </div>
        </el-drawer>
        <el-dialog
                title="添加备注(不少于10字)"
                :visible.sync="showDialog"
                width="50%"
                center
                @close="closeLikeDialog">
            <el-input
                    type="textarea"
                    :rows="2"
                    autosize
                    placeholder="请输入内容(不少于10字)"
                    v-model="remark" maxlength="500" minlength="10" show-word-limit>
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="remark.length<10" @click="saveRemark()">确 定</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                activeName: 0,
                activeName1: 0,
                //bankList:[],
                quesList:[],
                showDialog:false,
                formInline:{
                    period:1,
                },
                monthDate:new Date(),
                drawerShow:false,
                editIs:0,
                months:[],
                selectMonth:0,
                title:'',
                remark:'',
                curRow:null,
                //kpiType:[{id:1,name:"PL"},{id:2,name:"现金流"}],
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.getMonths();
            this.getKpiMonthRankingList();
            this.formInline.period=parseInt((new Date().getMonth() + 1)/3)
        },
        methods: {
            getKpiMonthRankingList() {

                this.$store.dispatch('getKpiMonthRanking',{year:this.monthDate.getFullYear(),month:this.selectMonth}).then(res=>{

                    //this.bankList = res
                    for(var index = 0;index < this.months.length;index++){
                        if(this.months[index].id==this.selectMonth){
                            var kpiType=[{id:1,name:"PL",data:res.pl},{id:2,name:"现金流",data:res.cash}];
                            this.months[index].kpiType=kpiType;

                        }

                    }
                    console.log(this.months)
                    //this.bankList.push("");
                })
            },
            getCooperativeQues(paperId,classId,questionClassName,userName,periodName) {
                this.drawerShow = true;
                this.title="季度KPI (标*必填)"+" :【"+userName+"】"+periodName;
                this.$store.dispatch('getQuarterKpiQuesInfo',{classId:classId,paperId:paperId}).then(res=>{
                    this.quesList = res
                })
            },
            formSubmit(){

            },
            handleClose(done) {
                this.quesList=[]
                done();
            },
            addRemark(row){
                this.curRow=row;
                this.remark=row.remark==null?'':row.remark;
                this.showDialog = true;
            },
            closeLikeDialog(){
                this.curRow={"remark":""};
            },
            saveRemark(){
                if(this.curRow!=null){
                    this.curRow.remark=this.remark;
                    console.log(this.curRow);
                    this.$store.dispatch('saveKpiRemark',this.curRow).then(res=>{
                        console.log(res);
                        this.showDialog = false
                        this.getKpiMonthRankingList()
                        //this.bankList = res
                    })
                }

            },
            getMonths(){
                var d=new Date();
                this.selectMonth=d.getMonth();
                var year=this.monthDate.getFullYear();

                for(var i=d.getMonth();i>=1;i--){
                    this.months.push({"id":i,"name":year+"年"+i+"月排行榜","kpiType":[]});
                }
            },
            handleClick(tab, event) {
                console.log(tab.index);
                this.selectMonth=this.months[tab.index].id;
                this.getKpiMonthRankingList();
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" >
    .el-drawer__header{
        /*color:#000000;*/
        margin-bottom:10px;
        font-size:20px;
    }
</style>




// WEBPACK FOOTER //
// src/components/cooperative/quarterKpiBank.vue